export const tribeoptions = [
	{ value: 'Bulwark', label: 'Bulwark', parm: 'tribe' },
	{ value: 'Daybreaker', label: 'Daybreaker', parm: 'tribe' },
	{ value: 'Guttersnipe', label: 'Guttersnipe', parm: 'tribe' },
	{ value: 'Medisapien', label: 'Medisapien', parm: 'tribe' },
	{ value: 'Skyraider', label: 'Skyraider', parm: 'tribe' },
	{ value: 'Sophisticate', label: 'Sophisticate', parm: 'tribe' },
	{ value: 'Subnautical', label: 'Subnautical', parm: 'tribe' },
	{ value: 'Tinkerer', label: 'Tinkerer', parm: 'tribe' },
];